import { render, staticRenderFns } from "./GenerateDatasetMenu.vue?vue&type=template&id=10868f40&"
import script from "./GenerateDatasetMenu.vue?vue&type=script&lang=ts&"
export * from "./GenerateDatasetMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateDatasetMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports